// extracted by mini-css-extract-plugin
export default {"noSearchResTips":"index_noSearchResTips_gRTPS"};